import React, { useEffect, useReducer } from "react";
import {
  msalApp,
  SCOPES
} from "utils/AuthUtils";
import { getSysUserApi } from 'utils/RoleUtils';

// If you support IE, our recommendation is that you sign-in using Redirect APIs
// const useRedirectFlow = true;

const reducer = (state, action) => {
  switch (action.type) {
    case "ACCOUNT_CHANGED":
      return {
        ...state,
        account: action.payload
      }
    case "APPLICATION_AUTH_CHANGED":
      return {
        ...state,
        title: action.payload.title,
        systemUserId: action.payload.systemUserId,
        name: action.payload.name,
        userName: action.payload.userName,
        isActive: action.payload.isActive,
        role: action.payload.role
      }
    case "TOKEN_CHANGED":
      return {
        ...state,
        token: action.payload
      }
    case "ERROR_CHANGED":
      return {
        ...state,
        error: action.payload
      }
    case "GRAPH_PROFILE_CHANGED":
      return {
        ...state,
        graphProfile: action.payload
      }
    default:
      return state
  }
}

// const storedRole = JSON.parse(window.localStorage.getItem('role'));

const initialState = {
  token: null,
  account: null,
  error: false,
  graphProfile: null,
  title: null, // storedRole ? storedRole.title : null,
  systemUserId: null, // storedRole ? storedRole.systemUserId : null,
  name: null, // storedRole ? storedRole.name : null,
  userName: null, // storedRole ? storedRole.userName : null,
  isActive: null, // storedRole ? storedRole.isActive : null,
  role: null, // storedRole ? new Role(storedRole) : null
};

const AuthContext = React.createContext(initialState);

const AuthProvider = ({ children }) => {

  const [state, dispatch] = useReducer(reducer, initialState);

  function onSignOut() {
    msalApp.logout();
  };


  const authRedirectCallBack = React.useCallback(function authRedirectCallBack(response, error) {
    // This function can be removed if you do not need to support IE
    async function getTokenRedirect(request) {
      return await msalApp.acquireTokenSilent(request)
        .then((response) => {
          if (response.accessToken) {
            const accessToken = response.accessToken;
            dispatch({ type: "TOKEN_CHANGED", payload: accessToken });
            dispatch({ type: "ACCOUNT_CHANGED", payload: getSignedInAccount().username });
          }
        })
        .catch(error => {
          console.warn("silent token acquisition fails. acquiring token using redirect");
          // fallback to interaction when silent call fails
          return msalApp.acquireTokenRedirect(request);
        });
    }
    if (error) {
      console.error(error);
    } else if (!response) {
      msalApp.loginRedirect(SCOPES.LOGIN);
    } else {
      console.log(msalApp)
      if (getSignedInAccount()) {
        // console.log('id_token acquired at: ' + new Date().toString());
        getTokenRedirect({ account: getSignedInAccount(), ...SCOPES.LOGIN });
      } else if (response.tokenType === "Bearer") {
      } else {
        // console.log("token type is:" + response.tokenType);
      }
    }
  }, []);

  function getSignedInAccount() {
    return msalApp.getAllAccounts()[0];
  };

  useEffect(() => {
    async function asyncEffects() {
      if (!state.token) {
        try {
          const response = await msalApp.acquireTokenSilent({ account: getSignedInAccount(), ...SCOPES.LOGIN });
          const accessToken = response.accessToken;
          dispatch({ type: "TOKEN_CHANGED", payload: accessToken });
          dispatch({ type: "ACCOUNT_CHANGED", payload: getSignedInAccount().username });
        } catch (e) {
          console.warn('token is expired, attempting re-login');
          const rd = await msalApp.handleRedirectPromise();
          authRedirectCallBack(rd);
        };
      };
    };
    asyncEffects();
  }, [state.token, authRedirectCallBack]);

  useEffect(() => {
    const asyncEffect = async () => {
      if (!state.role) {
        try {
          const [role, user] = await getSysUserApi();
          const authChangePayload = {
            title: user.title,
            systemUserId: user.systemUserId,
            name: user.name,
            userName: user.userName,
            isActive: user.isActive,
            role: role
          };
          dispatch({ type: "APPLICATION_AUTH_CHANGED", payload: authChangePayload });
        } catch(e) {
          dispatch({ type: "ERROR_CHANGED", payload: e })
        }
      };
    };
    // only update storage if no role is set
    state.account && state.token && asyncEffect();
  }, [state.account, state.role, state.token]);

  return (
    <AuthContext.Provider
      value={{
        account: state.account,
        error: state.error,
        graphProfile: state.graphProfile,
        systemUserId: state.systemUserId,
        name: state.name,
        userName: state.userName,
        isActive: state.isActive,
        role: state.role,
        onSignOut
      }}
    >
      {
      state.account && state.token && state.role && !state.error ? 
        children : // loaded correctly
          !state.error ?
          <div>Verifying your identity...</div> : // loading
          <div>{state.error.message}</div>
      }
    </AuthContext.Provider>
  )
}

export { AuthContext, AuthProvider };